import React from "react";
import { connect } from "react-redux";
import { clearData, fetchOrderDetails } from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectCanRequestSuspension,
  makeSelectCanCancelSuspension,
  makeSelectSuspensionPaymentDetails,
  makeSelectShowCardChargePrompt,
  makeSelectGuestOrderOrderRef,
  makeSelectOrderDetails,
  makeSelectSessionToken
} from "ducks/selectors";
import Spinner, { styles } from "components/Spinner";
import NotEligible from "components/NotEligible";
import { ORDER_ACTION_TYPES } from "utils/constants";
import RequestSuspension from "./RequestSuspension";
import { createStructuredSelector } from "reselect";
import isEmpty from "lodash/isEmpty";

export const SuspendNumberAction = props => {
  const { isFetchingOrderDetails, orderDetails, sessionToken } = props;

  if (!sessionToken) return <NotEligible />;

  if (isFetchingOrderDetails || isEmpty(orderDetails))
    return <Spinner size={200} sx={styles.fullPage} />;

  return <RequestSuspension {...props} />;
};

const mapStateToProps = createStructuredSelector({
  orderRef: makeSelectGuestOrderOrderRef(),
  orderDetails: makeSelectOrderDetails(),
  isFetchingOrderDetails: makeSelectIsFetchingData("orderDetails"),
  canCancelSuspension: makeSelectCanCancelSuspension(),
  canRequestSuspension: makeSelectCanRequestSuspension(),
  suspensionPaymentDetails: makeSelectSuspensionPaymentDetails(),
  showCardChargePrompt: makeSelectShowCardChargePrompt(),
  sessionToken: makeSelectSessionToken()
});

export function mapDispatchToProps(dispatch) {
  return {
    clearData: key => {
      dispatch(clearData(key));
    },
    fetchOrderDetails: orderRef => {
      const params = {
        type: ORDER_ACTION_TYPES.SUSPEND_NUMBER,
        order_ref: orderRef
      };

      dispatch(fetchOrderDetails(params));
    }
  };
}

SuspendNumberAction.defaultProps = {
  fetchOrderDetails: () => {}
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuspendNumberAction);
